export const translationStatus = (status) => {
    if (status === "active") return { color: "green", label: "Active" };
    if (status === "underReview") return { color: "yellow", label: "Under Review" };
    if (status === "translating") return { color: "yellow", label: "Translation In Progress" };
    if (status === "translation_successful") return { color: "green", label: "Translation Complete" };
    if (status === "translation_failed") return { color: "red", label: "Translation Failed" };
    if (status === "denied") return { color: "red", label: "Denied" };
    return { color: "red", label: "Inactive" };
};
